export default "__VITE_ASSET__33e9b11c__"